import React from 'react'
import Router from './router'

const App = () => {
  return(
    <div>
      <Router />
    </div>
  )
}

export default App